import React from "react";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

import AclTable from "../../../components/AclTable";
import UserCol from "../../../components/columns/UserCol";

import Card from "@mui/material/Card";
import MDBox from "materialDashboard/components/MDBox";


const CardPermissions = () => {
    const {t} = useTranslation(['workgroups']);
    const {workgroupId} = useParams();
    const resourceId = parseInt(workgroupId);

    const isPermissionDisabled = (user, permission) => {
        return (
            (user.role !== "WG_USER" && permission === "mod23_free:write")
            || (user.role === "WG_USER" && permission !== "mod23_free:write")
        );
    }

    return <Card>
        <MDBox py={2} px={2}>
            <AclTable title={t('workgroup.cardPermissions.title')}
                      principalType="user"
                      resourcesType="workgroup"
                      resourceId={resourceId}
                      permissions={['users:read', 'users:write', 'incidents:write', 'data:validate', 'data:write', 'mod23_free:write']}
                      entityHeader={t('workgroup.cardPermissions.user')}
                      renderEntityCol={(user) => <UserCol user={user}/>}
                      multipleCheck
                      entitySortFieldName="surname"
                      isPermissionDisabled={isPermissionDisabled}
                      dataTableProps={{canSearch: true, showTotalEntries: true, entriesPerPage: true}}
            />
        </MDBox>
    </Card>
}

export default CardPermissions;